import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal, Grid, Button } from 'semantic-ui-react';
import { AppState } from 'services/types';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

import ErrorAlert from 'components/ErrorAlert';
import SubmittingButton from 'components/SubmittingButton';
import { updateQueryString } from 'services/router/actions';
import { requestDeleteFertilizerEvent } from 'services/fertilizerEvents/actions';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';
// @ts-ignore
import { FERTILIZER_EVENT_DELETE_NAMESPACE } from 'services/fertilizerEvents/constants';
import { FERTILIZER_EVENT_DELETE_MODAL } from 'scenes/Fertilizer/constants';
import { FertilizerEventUuid } from 'services/fertilizerEvents/types';
import DeleteEventModalMessage from 'components/DeleteEventModalMessage';
import { selectSelectedFertilizerEventDates } from './selectors';
import { selectSelectedIncompleteFertilizerEventsUuids } from '../FertilizerEventsVirtualizedTable/selectors';

interface ConnectedProps {
    deleteFertilizerEventModal: boolean;
    uuids: FertilizerEventUuid[];
    dates: ReturnType<typeof selectSelectedFertilizerEventDates>;
}

interface DispatchProps {
    updateQueryString: typeof updateQueryString;
    requestDeleteFertilizerEvent: typeof requestDeleteFertilizerEvent;
}

type Props = ConnectedProps & DispatchProps;

export class FertilizerEventDeleteModalComponent extends React.PureComponent<Props> {
    get open(): boolean {
        const { deleteFertilizerEventModal, uuids } = this.props;

        return !!deleteFertilizerEventModal && !!uuids && !!uuids.length;
    }

    handleClose = (): void => {
        this.props.updateQueryString({
            [FERTILIZER_EVENT_DELETE_MODAL]: undefined
        });
    };

    handleDeleteFertilizerEvent = (): void => {
        const { uuids } = this.props;

        this.props.requestDeleteFertilizerEvent(uuids);
    };

    render(): React.ReactElement {
        const { uuids, dates } = this.props;

        return (
            <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                <Modal
                    open={this.open}
                    onClose={this.handleClose}
                    size="tiny"
                    centered={false}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace={FERTILIZER_EVENT_DELETE_NAMESPACE}
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <Modal.Header>
                            Delete Fertilizer{' '}
                            {uuids.length > 1 ? 'Events' : 'Event'}
                        </Modal.Header>
                        <Modal.Content>
                            <DeleteEventModalMessage
                                uuids={uuids}
                                dates={dates}
                                eventName="Fertilizer Event"
                                eventPluralName="Fertilizer Events"
                            />
                            <ErrorAlert
                                namespace={FERTILIZER_EVENT_DELETE_NAMESPACE}
                            />
                            <Grid>
                                <Grid.Column
                                    mobile={16}
                                    tablet={8}
                                    computer={8}
                                >
                                    <Button
                                        type="button"
                                        onClick={this.handleClose}
                                        fluid
                                        basic
                                        primary
                                    >
                                        Cancel
                                    </Button>
                                </Grid.Column>
                                <Grid.Column
                                    mobile={16}
                                    tablet={8}
                                    computer={8}
                                >
                                    <SubmittingButton
                                        type="button"
                                        namespace={
                                            FERTILIZER_EVENT_DELETE_NAMESPACE
                                        }
                                        negative
                                        fluid
                                        onClick={
                                            this.handleDeleteFertilizerEvent
                                        }
                                    >
                                        Delete
                                    </SubmittingButton>
                                </Grid.Column>
                            </Grid>
                        </Modal.Content>
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    deleteFertilizerEventModal: makeSelectQueryStringValue(
        FERTILIZER_EVENT_DELETE_MODAL
    ),
    uuids: selectSelectedIncompleteFertilizerEventsUuids,
    dates: selectSelectedFertilizerEventDates
});

export default connect(mapStateToProps, {
    updateQueryString,
    requestDeleteFertilizerEvent
})(FertilizerEventDeleteModalComponent);
